import { render } from "./PolicyReviewStatusOnboardComponent.vue?vue&type=template&id=74fcc600&scoped=true"
import script from "./PolicyReviewStatusOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyReviewStatusOnboardComponent.vue?vue&type=script&lang=js"

import "./PolicyReviewStatusOnboardComponent.vue?vue&type=style&index=0&id=74fcc600&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fcc600"]])

export default __exports__